import React, { Component } from "react";
import { Table, Button, Input } from "antd";
import moment from "moment";

import { apiFeedback } from "../../../../api/api-feedback";
import { emitter } from "../../../../common/utils/emitter";
import { alert } from "../../../../common/utils/alert";

const { TextArea } = Input;

export class CustomerReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remainingWord: 1000,
      errorMessage: "",
      dataTable: [],
      total: 0,
    };
    this.page = 1;
  }

  countdownCharacter = (e) => {
    let length = e.target.value.length;
    this.setState({
      remainingWord: 1000 - length,
      content: e.target.value,
      errorMessage: "",
    });
  };

  handleSentReview = async () => {
    if (this.state.content) {
      const content = this.state.content.trim();
      emitter.emit("FETCH_LOADING", true);
      const result = await apiFeedback.createFeedback(content);
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        alert("success", "Gửi nhận xét đánh giá thành công!");
        this.setState({
          remainingWord: 1000,
          errorMessage: "",
        });
        document.getElementsByClassName("text-review")[0].value = "";
        this.setState({
          dataTable: [
            { ...result.data, data: result.data, expand: false },
            ...this.state.dataTable,
          ],
          total: this.state.total + 1,
        });
      } else {
        emitter.emit("FETCH_LOADING", false);
        alert("error", result.data.message);
      }
    } else {
      this.setState({
        errorMessage: "Vui lòng nhập nội dung đánh giá!",
      });
    }
  };

  expandText = (data) => {
    for (let i = 0; i < this.state.dataTable.length; i++) {
      if (this.state.dataTable[i].id === data.id) {
        let newDataTable = [...this.state.dataTable];
        newDataTable[i].expand = true;
        this.setState({
          dataTable: [...newDataTable],
        });
      }
    }
  };

  compactText = (data) => {
    for (let i = 0; i < this.state.dataTable.length; i++) {
      if (this.state.dataTable[i].id === data.id) {
        let newDataTable = [...this.state.dataTable];
        newDataTable[i].expand = false;
        this.setState({
          dataTable: [...newDataTable],
        });
      }
    }
  };

  componentDidMount() {
    this.getData(1);
  }

  getData = async (page) => {
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiFeedback.getFeedBackByUser(page);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            ...value,
            data: value,
            expand: false,
          };
        });
        this.setState(
          { dataTable: dataConvert, total: result.data.total_elements },
          () => {}
        );
      }
    } catch (error) {
    } finally {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  onChangePage = (page) => {
    this.getData(page);
  };

  customerTable = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      maxWidth: 60,
      render: (a, b, index) => <span>{index + 1}</span>,
    },
    {
      title: "Nội dung đánh giá",
      dataIndex: "",
      key: "",
      render: (data) => {
        let content = data.content
          .split(" ")
          .filter((item) => item !== "")
          .join(" ")
          .split("\n");
        let compactText = data.content
          .split(" ")
          .filter((item) => item !== "")
          .join(" ")
          .slice(0, 100)
          .split("\n");
        return (
          <div className="review-text">
            {!data.expand &&
              compactText.map((item, index) => {
                if (
                  index === compactText.length - 1 ||
                  compactText.length === 1
                ) {
                  return (
                    <span key={index} className="review-content">
                      {item}
                    </span>
                  );
                }
                return (
                  <span className="review-content">
                    {item} <br />
                  </span>
                );
              })}
            {data.expand &&
              content.map((item, index) => {
                if (index === content.length - 1 || content.length === 1) {
                  return (
                    <span key={index} className="review-content">
                      {item}
                    </span>
                  );
                }
                return (
                  <span className="review-content">
                    {item} <br />
                  </span>
                );
              })}
            {data.content
              .split(" ")
              .filter((item) => item !== "")
              .join(" ").length > data.content.slice(0, 100).length &&
              data.expand === false && (
                <>
                  {" "}
                  ...{" "}
                  <span
                    style={{ color: "cornflowerblue", cursor: "pointer" }}
                    onClick={() => this.expandText(data)}
                    className="seeMore"
                  >
                    Xem thêm
                  </span>
                </>
              )}
            {data.content
              .split(" ")
              .filter((item) => item !== "")
              .join(" ").length > data.content.slice(0, 100).length &&
              data.expand === true && (
                <span
                  onClick={() => this.compactText(data)}
                  style={{ color: "cornflowerblue", cursor: "pointer" }}
                  className="seeMore"
                >
                  {" "}
                  Ẩn bớt
                </span>
              )}
          </div>
        );
      },
    },
    {
      title: "Thời gian",
      dataIndex: "created_at",
      key: "created_at",
      render: (item) => {
        const time_unix = moment(item).format("DD/MM/YYYY");
        return item ? <span>{time_unix}</span> : null;
      },
    },
  ];

  render() {
    const { remainingWord, errorMessage, dataTable, total } = this.state;
    return (
      <>
        <div className="customer-review">
          <div
            style={{ color: "#d20a30", paddingTop: "20px", fontSize: "1em" }}
          >
            Nhận xét đánh giá
          </div>
          <div style={{ margin: "10px 0px" }}>
            Gửi nhận xét đánh giá của quý khách hàng với bộ phận CSKH Avis (nếu
            có vấn đề về dịch vụ hoặc tài xế, quý khách vui lòng cung cấp cho
            Avis tên tài xế kèm ngày phát sinh sự cố hoặc các thông tin liên
            quan để Avis hỗ trợ được nhanh nhất).
          </div>
          <TextArea
            onChange={this.countdownCharacter}
            rows={6}
            maxLength={1000}
            className="text-review"
            withspellcheck="false"
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="text-count-down">{remainingWord}/1000 ký tự</div>
            <div style={{ color: "rgb(210, 10, 48)", fontSize: "12px" }}>
              {errorMessage}
            </div>
          </div>
          <div className="button-container">
            <Button className="sent-review-btn" onClick={this.handleSentReview}>
              Gửi đánh giá
            </Button>
          </div>

          <div style={{ width: "100%", height: "100%", marginTop: 10 }}>
            <div style={{ color: "#d20a30", fontSize: "1em" }}>
              Nhận xét đánh giá
            </div>
            <Table
              className="review-table-container"
              rowKey="id"
              dataSource={dataTable}
              pagination={{
                total,
                pageSize: 10,
                onChange: this.onChangePage,
                current: this.page,
              }}
              columns={this.customerTable}
            />
          </div>
        </div>
      </>
    );
  }
}
